import {
  ForkKnife, Drop, BowlFood, Jar,
  Martini, Oven, DropHalfBottom, PawPrint, SquaresFour
} from "@phosphor-icons/react";

export const PRODUCT_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "savory", label: "Savory" },
  { key: "beverage", label: "Beverages" },
  { key: "baked_goods", label: "Baked goods" },
  { key: "dairy_plant", label: "Dairy / plant-based" },
  { key: "pet", label: "Pet" },
];

export const PRODUCT_TYPES = {
  // Savory
  dry_blend:    { label: "Dry blend",           category: "savory",       icon: ForkKnife,      ring: "ring-emerald-300", text: "text-emerald-800", bg: "bg-emerald-50" },
  wet_sauce:    { label: "Wet sauce",           category: "savory",       icon: Drop,           ring: "ring-rose-300",    text: "text-rose-800",    bg: "bg-rose-50" },
  dressing:     { label: "Dressing",            category: "savory",       icon: Drop,           ring: "ring-violet-300",  text: "text-violet-800",  bg: "bg-violet-50" },
  broth:        { label: "Broth / soup",        category: "savory",       icon: BowlFood,       ring: "ring-amber-300",   text: "text-amber-800",   bg: "bg-amber-50" },
  wet_marinade: { label: "Wet marinade",        category: "savory",       icon: Jar,            ring: "ring-blue-300",    text: "text-blue-800",    bg: "bg-blue-50" },
  
  // Beverage
  beverage:     { label: "Beverage",            category: "beverage",     icon: Martini,        ring: "ring-fuchsia-300", text: "text-fuchsia-800", bg: "bg-fuchsia-50" },
  
  // Baked Goods
  baked_goods:  { label: "Baked goods",         category: "baked_goods",  icon: Oven,           ring: "ring-orange-300",  text: "text-orange-800",  bg: "bg-orange-50" },
  
  // Dairy / Plant
  dairy_plant:  { label: "Dairy / plant-based", category: "dairy_plant",  icon: DropHalfBottom, ring: "ring-sky-300",     text: "text-sky-800",     bg: "bg-sky-50" },
  
  // Pet
  pet_topper:   { label: "Pet topper",          category: "pet",          icon: PawPrint,       ring: "ring-stone-400",   text: "text-stone-800",   bg: "bg-stone-100" },
};

export function getProductType(key) {
  return PRODUCT_TYPES[key] || PRODUCT_TYPES.dry_blend;
}

export function filterByCategory(items, categoryKey) {
  if (categoryKey === "all") return items;
  return items.filter(item => {
    const pt = getProductType(item.product_type);
    return pt.category === categoryKey;
  });
}

const WET_SAVORY_TYPES = new Set(["wet_sauce", "wet_marinade", "dressing", "broth"]);
const LIQUID_PRODUCT_TYPES = new Set(["wet_sauce", "wet_marinade", "dressing", "broth", "beverage"]);

export function usesWetSavorySafetyTools(productType) {
  return WET_SAVORY_TYPES.has(productType);
}

export function usesLiquidMeasurements(productType, productForm) {
  return LIQUID_PRODUCT_TYPES.has(productType)
    || (productType === "dairy_plant" && productForm === "liquid");
}

export function calculateAverageDensity(rows, getDensity = (row) => row?.density_g_ml) {
  let totalMass = 0;
  let totalVolume = 0;
  for (const row of rows || []) {
    const grams = Number(row?.grams) || 0;
    if (grams <= 0) continue;
    const resolved = Number(getDensity(row));
    const density = resolved > 0 ? resolved : 1.0;
    totalMass += grams;
    totalVolume += grams / density;
  }
  return totalVolume > 0 ? totalMass / totalVolume : 1.0;
}

// Gives an icon mapped to the broad category
export function getCategoryIcon(categoryKey) {
  switch (categoryKey) {
    case "all": return SquaresFour;
    case "savory": return ForkKnife;
    case "beverage": return Martini;
    case "baked_goods": return Oven;
    case "dairy_plant": return DropHalfBottom;
    case "pet": return PawPrint;
    default: return SquaresFour;
  }
}
